<div class="row">
  <div class="col-lg-12" style="margin-bottom: 5px">
    <button
      i18n="@@Back"
      nbButton
      outline
      status="success"
      type="submit"
      [disabled]="updatingTemplate"
      class="back btn ButtonMargins btn-circle btn-xl"
      (click)="Back()"
    >
      <nb-icon icon="arrow-ios-back-outline"></nb-icon>Back to Program Template
    </button>
  </div>
</div>
<nb-card>
<nb-card-body>
  <div class="row">
    <div class="col-lg-12">
      <ul class="basic_list_informations row">
        <li
          i18n="@@PlanName"
          class="GeneralLabel2 template-name-row col-sm-2"
        >
          Plan Name
        </li>
        <li class="name-editors col-sm-10">
          
          <smart-edit
            status="primary"
            (change)="onNameChange($event)"
            [ngModel]="template?.name"
            i18n-placeholder="@@PlanName"
            placeholder="Plan Name"
          ></smart-edit>
        </li>
      </ul>
    </div>
  </div>
  <mat-tab-group
    class="tab"
    #tabGroup
   [selectedIndex]="selectedIndex"
   (selectedTabChange)="onChangeTab($event)"
  >
  <!-- (selectedTabChange)="onChangeTab($event)" -->
  <!-- Programs -->
  <mat-tab label="Programs" i18n-tabTitle="@@Programs" tabindex="0">
    <ng-template mat-tab-label>
      <span class="fas fa-calendar-alt"></span>
      <span class="ml-1">Programs</span>
    </ng-template>
    <div class="mt-3" style="overflow: hidden !important;">
    <ngx-patient-calendar isProgramTemplate="true"></ngx-patient-calendar>
  </div>
  </mat-tab>
    <!-- Workout Plans -->
    <mat-tab
      i18n-tabTitle="@@WorkoutPlans"
      label="Workout Plans"
      tabindex="1"
    >
      <ng-template mat-tab-label>
        <span class="fas fa-dumbbell"></span>
        <span class="ml-1">Workout Plans</span>
      </ng-template>
      <app-patient-program [isFitness]="true" [isProgramTemplate]="true"></app-patient-program>
    </mat-tab>

    <!-- Meal Plans -->
    <mat-tab i18n-tabTitle="@@MealPlans" label="Meal Plans" tabindex="2">
      <ng-template mat-tab-label>
        <span class="fas fa-utensils"></span>
        <span class="ml-1">Meal Plans</span>
      </ng-template>
      <app-patient-program [isFitness]="false" [isProgramTemplate]="true"></app-patient-program>
    </mat-tab>
  </mat-tab-group>
</nb-card-body>
</nb-card>